export const IkeUserRole = {
	USER: 'user' as const,
	ROOT: 'root' as const,
	EDITOR: 'editor' as const,
	VIEWER: 'viewer' as const,
	DOWNLOADER: 'downloader' as const,
	DATA_ADMIN: 'data-admin' as const,
	/**
	 * User has no permissions for this department
	 */
	NONE: 'none' as const,
};

/**
 * Type of provided values for User Roles.
 */
export type IkeUserRole =
	| typeof IkeUserRole.USER
	| typeof IkeUserRole.NONE
	| typeof IkeUserRole.ROOT
	| typeof IkeUserRole.EDITOR
	| typeof IkeUserRole.VIEWER
	| typeof IkeUserRole.DOWNLOADER
	| typeof IkeUserRole.DATA_ADMIN;
